import type { LucideIcon } from 'lucide-react';
import {
  Orbit, Shield, Ship, Plane, Crosshair, Radio, Radar, Flame,
  Ambulance, AlertTriangle, Truck, Zap, Eye, Search, BarChart3,
  Users, MapPin, Sun, Puzzle, Activity, Rocket, Cctv,
} from 'lucide-react';

/**
 * Maps Lucide icon name strings to icon components.
 * Used by the plugin system to resolve icon names from server config.
 */
export const LUCIDE_ICON_MAP: Record<string, LucideIcon> = {
  Orbit,
  Shield,
  Ship,
  Plane,
  Crosshair,
  Radio,
  Radar,
  Flame,
  Ambulance,
  AlertTriangle,
  Truck,
  Zap,
  Eye,
  Search,
  BarChart3,
  Users,
  MapPin,
  Sun,
  Puzzle,
  Activity,
  Rocket,
  Cctv,
};

/** Resolve a Lucide icon name string to a component. Falls back to Puzzle. */
export function resolveIcon(name: string): LucideIcon {
  return LUCIDE_ICON_MAP[name] ?? Puzzle;
}
